module.exports = __webpack_public_path__ + "img/newnewBackground.7dbc52ef.svg";